import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import {
  getLocationCompanyContactListData,
  processAfterAddOrUpdateLocationCompanyContactListData,
  processAfterDeleteLocationCompanyContactListData,
} from './mockData'

// post

const postLocationCompanyContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(
    req,
    res,
    ctx,
    getLocationCompanyContactListData,
    processAfterAddOrUpdateLocationCompanyContactListData
  )
}

const patchLocationCompanyContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(
    req,
    res,
    ctx,
    getLocationCompanyContactListData,
    [processAfterAddOrUpdateLocationCompanyContactListData]
  )
}

const deleteLocationCompanyContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(
    req,
    res,
    ctx,
    getLocationCompanyContactListData,
    processAfterDeleteLocationCompanyContactListData
  )
}

export const handlers = [
  {
    method: 'post',
    path: '/api/locationcompanycontacts',
    handler: postLocationCompanyContact,
  },
  {
    method: 'patch',
    path: '/api/locationcompanycontacts/:id',
    handler: patchLocationCompanyContact,
  },
  {
    method: 'delete',
    path: '/api/locationcompanycontacts/:id',
    handler: deleteLocationCompanyContact,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
